module.exports = __webpack_public_path__ + "static/media/noPkImage.b44770dd.svg";